module.exports = __webpack_public_path__ + "static/media/default_avatar.90dc4ad0.svg";